import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
} from '@angular/core';
import type { UiActionMenuItem } from '../../types/ui-action-menu-item.interface';

@Component({
  selector: 'ui-action-menu',
  imports: [],
  templateUrl: './ui-action-menu.component.html',
  styleUrl: './ui-action-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiActionMenuComponent {
  public readonly items: InputSignal<readonly UiActionMenuItem[]> =
    input.required<readonly UiActionMenuItem[]>();
  public readonly ariaLabel: InputSignal<string> = input.required<string>();
  public readonly triggerLabel: InputSignal<string> = input<string>('...');
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly itemSelected: OutputEmitterRef<string> = output<string>();

  protected handleSummaryClick(event: MouseEvent): void {
    if (!this.disabled()) {
      return;
    }

    event.preventDefault();
  }

  protected handleItemSelected(item: UiActionMenuItem, menu: HTMLDetailsElement): void {
    if (item.disabled === true) {
      return;
    }

    menu.open = false;
    this.itemSelected.emit(item.id);
  }
}
